import React, { useContext, useState } from "react";
import {
  Alert,
  Box,
  Container,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
// import { addOrganization } from "../Redux/organizationReducer";
import { useTranslations, useForm } from "hooks";
import { getTranslation } from "common";
import { noTokenApi } from "api";
import { Validation, isRequired } from "hooks/useForm";
import { AuthContext } from "contexts";
import { AuthSidebar } from "components";
import { Step } from "components/LandingSidebar";
import FlowentiButton from "components/flowenti-ui-kit/FlowentiButton";
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';

const Organization = () => {
  // const [email, setEmail] = useState<string>("");
  const translations = useTranslations();
  const [emailSent, setEmailSent] = useState<boolean>(false);
  // const dispatch = useDispatch();
  const {
    state: { registerUser: user },
    actions: { setUser },
  } = useContext(AuthContext);
  // const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const organizationInitial: string | undefined = getTranslation(
    translations,
    "register.label.edit_myOrganization"
  );
  const validations: Validation[] = [
    ({ organization }) =>
      isRequired(organization) || {
        organization: getTranslation(translations, "register.fieldrequired"),
      },
  ];
  const { values, changeHandler, errors, touched, isValid } = useForm(
    {
      organization: !organizationInitial ? "" : organizationInitial,
      emails: [],
    },
    validations
  );

  const handleSubmit = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    try {
      e.preventDefault();
      setLoading(true);
      const result = await noTokenApi.post(
        `/organizations?create_template=true`,
        {
          name: values.organization,
        },
        { headers: { Authorization: `Bearer ${user?.jwt}` } }
      );

      const organizationId = result.data.id;

      // dispatch(
      //   addOrganization({
      //     id: organizationId,
      //     name: values.organization,
      //   })
      // );

      // await noTokenApi.post(
      //   `/organizations/${organizationId}/users/${user?.userId}`,
      //   undefined,
      //   { headers: { Authorization: `Bearer ${user?.jwt}` } }
      // );
      if (values.emails.length > 0) {
        await noTokenApi.post(
          `/users/${user?.userId}/organizations/${organizationId}/inviteusers`,
          {
            email: values.emails,
          }
        );
      }
      setEmailSent(true);
      // navigate("/login", { state: { fromRegister: true } });
    } catch {
      setLoading(false);
    } finally {
    }
  };

  const steps: Step[] = [
    {
      number: 1,
      title: getTranslation(translations, "setup.organization_title1"),
      description: getTranslation(translations, "setup.organization_description1")
    },
    {
      number: 2,
      title: getTranslation(translations, "setup.organization_title2"),
      description: getTranslation(translations, "setup.organization_description2")
    },
  ];

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        background: "#f5f5f5",
        flexDirection: { xs: "column-reverse", md: "row" },
        // mr: { xs: 2, md: 46 }
      }}
    >
      <AuthSidebar
        title={getTranslation(translations, "set.up.organization_title")}
        steps={steps}
      />

      {/* Right Section - Organization Form */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: { xs: 3, md: 6 },
          background: "#fafafa",
        }}
      >
        <Container
          maxWidth="sm"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            component="form"
            sx={{
              width: '100%',
              maxWidth: 480,
            }}
          >
            <Typography
              variant="h4"
              sx={{
                fontSize: "1.75rem",
                fontWeight: 600,
                color: "#1a2332",
                mb: 2,
              }}
            >
              {getTranslation(
                translations,
                "register.label.organization_name_insert"
              )}
            </Typography>

            <Typography
              sx={{
                mb: 4,
                color: "text.secondary",
                lineHeight: 1.6,
                fontSize: "0.95rem",
              }}
            >
              {getTranslation(
                translations,
                "register.label.organization_name_describe"
              )}
            </Typography>

            <TextField
              size="medium"
              fullWidth
              error={Boolean(touched.organization && errors.organization)}
              helperText={touched.organization && errors.organization}
              onChange={(e) =>
                changeHandler("organization", e.target.value)
              }
              value={values.organization}
              label={getTranslation(
                translations,
                "register.label.organization_set_name"
              )}
              sx={{
                mb: 3,
                "& .MuiOutlinedInput-root": {
                  borderRadius: 1.5,
                  background: "white",
                }
              }}
            />

            {!emailSent && (
              <FlowentiButton
                id="organization-button"
                variant="contained"
                fullWidth
                type="submit"
                size="large"
                disabled={!isValid || loading}
                onClick={handleSubmit}
              >
                {loading ? getTranslation(translations, "generic.loading") : getTranslation(translations, "register.label.button_next")}
              </FlowentiButton>
            )}

            {emailSent && (
              <Box sx={{
                display: "flex",
                alignItems: "center",
                // justifyContent: "center",
              }}>
                <Alert
                  severity="success"
                  sx={{
                    borderRadius: 1.5,
                    "& .MuiAlert-message": {
                      display: "flex",
                      alignItems: "center",
                    },
                  }}
                >
                  {getTranslation(translations, "generic.check_your_email")}

                  {user?.authenticationtype != null && user?.authenticationtype !== 0 && (
                    <IconButton
                      onClick={() => {
                        setUser({
                          jwt: user.jwt || "",
                          userId: user.userId || -1,
                          email: user.email || "",
                          username: user.username || "",
                          firstname: user.firstname || "",
                          lastname: user.lastname || "",
                          picture: user.picture || "",
                          linkprofile: user.linkprofile || "",
                          subscriptiontype: user.subscriptiontype || 0,
                          i18n: user.i18n || "en",
                          dob: user.dob || null,
                          authenticationtype: user.authenticationtype,
                        });
                        console.log({
                          jwt: user.jwt || "",
                          userId: user.userId || -1,
                          email: user.email || "",
                          username: user.username || "",
                          firstname: user.firstname || "",
                          lastname: user.lastname || "",
                          picture: user.picture || "",
                          linkprofile: user.linkprofile || "",
                          subscriptiontype: user.subscriptiontype || 0,
                          i18n: user.i18n || "en",
                          dob: user.dob || null,
                          authenticationtype: user.authenticationtype,
                        })
                        // navigate("/dashboard/organizations");
                      }}
                      sx={{
                        marginLeft: 1,
                        minWidth: "auto",
                        padding: 0,
                      }}
                    >
                      <ArrowOutwardIcon color="disabled" />
                    </IconButton>
                  )}
                </Alert>
              </Box>
            )}
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default Organization;
